<app-breadcrumb [breadcrumb]="breadcrumb"></app-breadcrumb>
<!-- H1 duy nhất của trang listing (tên danh mục / kết quả tìm kiếm); ẩn hiển thị vì breadcrumb đã thể hiện. -->
<!-- <h1 class="visually-hidden">{{ heading }}</h1> -->

<section class="section-b-space shop-section pt-0" id="filtered_products">
  <div class="container-fluid-lg">
    <h1 class="h1-heading">{{ heading }}</h1>
    <div class="row">
      <div>
        <app-category-filter></app-category-filter>
      </div>
      <!-- <div *ngIf="hasFilters" class="filter" (click)="showSideBar(false)">
        <app-collection-filter></app-collection-filter>
      </div> -->
      <div class="col-custome-3">
        <div class="left-box border-0" [class.show]="offCanvasMenu">
          <div class="p-3 bg-white rounded-4">
            <app-collection-sidebar
              [filter]="filter"
              [showBackButton]="true"
              (closeSideBar)="showSideBar($event)"
            ></app-collection-sidebar>
          </div>
          <div
            *ngIf="isAuthenticated && recentProducts?.length"
            class="d-none d-xl-block d-xxl-block mt-3 p-3 bg-white rounded-4"
          >
            <app-recent-view-product></app-recent-view-product>
          </div>

          <!-- <div
            class="d-none d-xl-block d-xxl-block mt-3 p-3 bg-white rounded-4"
          >
            <app-new-post></app-new-post>
          </div> -->
        </div>
      </div>
      <div [class]="'col-custome-9'">
        <app-collection-sort
          *ngIf="isAuthenticated"
          [filter]="filter"
          [gridCol]="gridCol"
          (setGridClass)="setGridClass($event)"
          (showFilter)="showSideBar($event)"
        ></app-collection-sort>
        <!-- Gợi ý tìm kiếm (bảng map từ khóa, sản phẩm thay thế): phía trên kết quả thường, chỉ hiện khi có và khách đã đăng nhập -->
        <app-search-suggestions [isListView]="isListView" (visibleChange)="hasSuggestions = $event" (pendingChange)="suggestionPending = $event"></app-search-suggestions>
        <h5 *ngIf="hasSuggestions" class="mb-3 fw-semibold">
          Kết quả cho “{{ currentSearchTerm }}”
        </h5>
        <!-- Đang tải: skeleton (trước đây khối skeleton nằm trong khung chỉ hiện khi đã có sản phẩm nên không bao giờ thấy) -->
        <div
          *ngIf="(skeletonLoader || suggestionPending) && !products.length && !productsExtend.length"
          class="gutter"
          [class]="gridClass"
        >
          <app-skeleton-product-box
            *ngFor="let item of skeletonItems"
          ></app-skeleton-product-box>
        </div>
        <!-- Có gợi ý nhưng tìm thường không ra gì: nói rõ để không bị nhầm gợi ý là kết quả của từ khóa -->
        <p
          *ngIf="hasSuggestions && !skeletonLoader && !products.length && !productsExtend.length"
          class="text-muted mb-3"
        >
          Không tìm thấy sản phẩm nào cho “{{ currentSearchTerm }}”.
        </p>
        <div
          *ngIf="products.length && products.length > 0"
          class="gutter"
          [class]="gridClass"
        >
          <ng-container
            *ngIf="skeletonLoader && !products.length; else productContent"
          >
            <app-skeleton-product-box
              *ngFor="let item of skeletonItems"
            ></app-skeleton-product-box>
          </ng-container>
          <ng-template #productContent>
            <ng-container *ngFor="let product of products; trackBy: trackByProduct">
              <app-product-box
                [product]="product"
                [isListView]="isListView"
                [class]="'product-box-3'"
                [style]="'horizontal'"
                (productLabel)="queryStringBuilder($event)"
              ></app-product-box>
            </ng-container>
          </ng-template>
        </div>
        <div *ngIf="!isVipCustomer && !skeletonLoader &&
            productsExtend.length &&
            productsExtend.length > 0" style="line-height: 16px; padding-bottom: 8px; font-style: italic; color: #CF1322;">
          *Giá bạn đang xem là giá đã giảm sau khi áp dụng các chương trình bán hàng như chiết khấu trên đơn, chiết khấu sản phẩm, mã ưu đãi cho khách hàng và các ưu đãi khác...
        </div>
        <div
          *ngIf="productsExtend.length && productsExtend.length > 0"
          class="product-grid"
        >
          <ng-container
            *ngIf="
              skeletonLoader && !productsExtend.length;
              else productContentExtend
            "
          >
            <app-skeleton-product-box
              *ngFor="let item of skeletonItems"
            ></app-skeleton-product-box>
          </ng-container>

          <ng-template #productContentExtend>
            <ng-container *ngFor="let product of productsExtendDisplay; trackBy: trackByDisplayItem">
              @if (product.type === "product") {
                <app-product-box
                  [product]="product"
                  [isListView]="isListView"
                  [style]="'horizontal'"
                  (productLabel)="queryStringBuilder($event)"
                ></app-product-box>
              }
              @if (product.type === "banner") {
                <div class="banner" [ngClass]="{'d-none': !productBanner}">
                  <app-banner-policy
                    [banners]="productBanner"
                  ></app-banner-policy>
                </div>
              }
            </ng-container>
          </ng-template>
        </div>
        <div *ngIf="listingError" class="alert alert-danger" role="alert">
          Không thể tải sản phẩm. Vui lòng thử lại.
          <button type="button" class="btn btn-link" (click)="retryListing()">Thử lại</button>
        </div>
        <app-no-data
          [class]="'no-data-added collection-no-data'"
          [image]="'assets/svg/no-product.svg'"
          [text]="'Không tìm thấy sản phẩm nào!'"
          [description]="'Bạn hãy thử tìm lại với từ khóa khác nhé!'"
          *ngIf="
            products.length == 0 &&
            productsExtend.length == 0 &&
            !skeletonLoader &&
            !listingError &&
            !suggestionPending &&
            !hasSuggestions
          "
        >
        </app-no-data>
        <app-collection-paginate [hidden]="listingError || skeletonLoader"> </app-collection-paginate>

        <div
          *ngIf="isAuthenticated"
          class="d-block d-xl-none d-xxl-none p-3 bg-white rounded-4"
          style="margin-top: 12px"
        >
          <app-recent-view-product></app-recent-view-product>
        </div>

        <div
          style="margin-top: 16px"
        >
          <app-new-post></app-new-post>
        </div>
      </div>
    </div>
  </div>
</section>
